import React from 'react';
import PropTypes from 'prop-types';
import { headerRow, lineStyles } from './BacsTableCss';

const BacsTable = ({ bacsDetails, renderHeader, renderBody, renderFooter, showFooter }) => (
	<div>
		{renderHeader && <div className={headerRow}>{renderHeader()}</div>}
		{bacsDetails.payments.map((payment) => (
			<div className={lineStyles} key={payment.id}>
				{renderBody(payment)}
			</div>
		))}
		{showFooter && renderFooter && <div className={lineStyles}>{renderFooter()}</div>}
	</div>
);

BacsTable.propTypes = {
	bacsDetails: PropTypes.shape({}).isRequired,
	renderBody: PropTypes.func.isRequired,
	renderHeader: PropTypes.func,
	renderFooter: PropTypes.func,
	showFooter: PropTypes.bool,
};

export default BacsTable;
